module.exports = __webpack_public_path__ + "img/login.ff11dcc0.jpg";